module.exports = __webpack_public_path__ + "img/weingutloewenstein_2.eaff6cda.jpg";